import { useState, useEffect } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { roles } from './AuthService';
import { useStateValue } from './ContextProvider';

export const GuardedRoute = ({ Component, ...rest }) => {
  const { userState } = useStateValue();
  const [loggedIn, setLoggedIn] = useState(userState.loggedUserData ? userState.loggedUserData.role === roles.ADMIN : false);

  useEffect(() => {
    setLoggedIn(userState.loggedUserData ? userState.loggedUserData.role === roles.ADMIN : false);
  }, [userState.loggedUserData]);

  useEffect(() => {
    console.log('Guarded route');
  }, []);


  if (loggedIn) {
    return (
      <Component />
    );
  }
  return (
    <Redirect to='/' />
  );
};